<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.04.19</b> - Some bug fixes</p>
    <div class="ml-5 pb-4 text-green-400">
      <ul class="ml-4 list-disc">
        <li>Fixed infinite loops that could occur when equipping bags</li>
        <li>Fixed UI bugs when dragging equipped bags between slots</li>
        <li>Fixed errors in the Edit Equipment screen</li>
        <li>Fixed issues with the Inn Tournament system not updating correctly</li>
        <li>Fixed Caverns tile text display issues</li>
      </ul>
    </div>
  </div>
</template>
